import { IconButton } from "@mui/material";
import { KebabSingleIcon } from "@gx1/gx-npm-ui";
import { KeyboardEvent, MouseEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./kebab-menu.styles.module.scss";
import classNames from "classnames";
import { MenuSingleSelectComponent } from "@gx1/gx-ui-common";

type KebabMenuProps = {
  onClickArchive: () => void;
  onClickDelete: () => void;
  isDisabled?: boolean;
};

const KebabMenuComponent = ({
  onClickArchive, onClickDelete, isDisabled = false
}: KebabMenuProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setAnchorEl(event.currentTarget);
    }
  };

  const handleKeyUp = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === " ") {
      event.preventDefault();
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      type: "action" as const,
      label: "Archive",
      onClick: () => {
        onClickArchive();
        handleClose();
      }
    },
    {
      type: "action" as const,
      label: "Delete",
      onClick: () => {
        onClickDelete();
        handleClose();
      }
    }
  ];

  return (
    <div>
      <IconButton
        aria-label={t("evaluation options")}
        aria-expanded={open}
        aria-haspopup="menu"
        onClick={handleClickOpen}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        disabled={isDisabled}
        className={classNames(styles.kebabButton, { [styles.kebabButtonOpen]: open })}
      >
        <KebabSingleIcon />
      </IconButton>
      <MenuSingleSelectComponent
        anchorEl={anchorEl}
        items={menuItems}
        open={open}
        onClose={handleClose}
        menuPosition={"left"}
        onItemClick={(_i, item) =>
          menuItems.find(x => item.type !== "divider" ? x.label === item?.label : false)?.onClick()}
      />
    </div>
  );
};

export default KebabMenuComponent;
